export const noop = () => {
    // This noop function is intentionally left empty
};
